export default __webpack_public_path__ + "static/media/MarkForLater_Active.c4dbded5.svg";